<template>
	<div class="test-vue">
		<svg :width="radius" :height="radius" viewBox="-100 -100 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg">
			<circle v-for="(item, index) in circleR" fill="#F29123" cx="0" cy="-50" :r="item" :class="'roateCircle ' + index"></circle>
		</svg>
	</div>
</template>

<script type="text/ecmascript-6">
export default {
	props: {
		radius: {
        type: Number,
        default: 60
     }
	},
	data() {
		return {
			circleR: {a1:10,a2:9,a3:7,a4:5,a5:3.5}
		}
	}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	.roateCircle
		animation: action 2s ease-in-out infinite
	.a2
		animation-delay: 0.1s
	.a3
		animation-delay: 0.2s
	.a4
		animation-delay: 0.28s
	.a5
		animation-delay: 0.34s

	@keyframes action 
		0%
			transform: rotate(0deg)
		10%
			transform: rotate(0deg)
		100%
			transform: rotate(360deg)
</style>



// WEBPACK FOOTER //
// src/common/load-img/load-img.vue